import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Users, ChevronLeft, ChevronRight } from "lucide-react";

// Stabiele key per groep binnen deze locatie — voorkomt state-lek bij herordenen
// wanneer gebruiker aantal-groepen wijzigt.
const groupKey = (locIdx, gIdx) => `loc-${locIdx}-grp-${gIdx}`;

export default function Step3Groepen({
  currentLoc, aantal, locatie,
  onGroupChange, onBack, onNextLoc, onGotoReview,
}) {
  return (
    <Card className="p-6 space-y-4" data-testid="wizard-step-3">
      <h2 className="text-xl font-medium flex items-center gap-2">
        <Users className="h-5 w-5" /> Groepen — {locatie.name || `Locatie ${currentLoc + 1}`}
      </h2>
      {locatie.groepen.map((g, gIdx) => (
        <div key={groupKey(currentLoc, gIdx)}
             className="border rounded-md p-4 bg-neutral-50"
             data-testid={`wizard-group-${currentLoc}-${gIdx}`}>
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">Groep {gIdx + 1}</div>
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2">
              <Label>Groepsnaam *</Label>
              <Input value={g.name}
                     onChange={e => onGroupChange(gIdx, { name: e.target.value })}
                     data-testid={`wizard-group-name-${currentLoc}-${gIdx}`}
                     placeholder="Bijv. Baby's, Peuters, BSO 4-7" />
            </div>
            <div>
              <Label>Opvangsoort</Label>
              <Select value={g.opvangsoort}
                      onValueChange={v => onGroupChange(gIdx, { opvangsoort: v })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent className="bg-white">
                  <SelectItem value="KDV">KDV</SelectItem>
                  <SelectItem value="BSO">BSO</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Capaciteit *</Label>
              <Input type="number" min={1} value={g.capaciteit}
                     onChange={e => onGroupChange(gIdx, { capaciteit: e.target.value })} />
            </div>
            <div>
              <Label>Leeftijd min (jr)</Label>
              <Input type="number" step="0.5" min={0} value={g.leeftijd_min}
                     onChange={e => onGroupChange(gIdx, { leeftijd_min: e.target.value })} />
            </div>
            <div>
              <Label>Leeftijd max (jr)</Label>
              <Input type="number" step="0.5" min={0} value={g.leeftijd_max}
                     onChange={e => onGroupChange(gIdx, { leeftijd_max: e.target.value })} />
            </div>
          </div>
        </div>
      ))}
      <div className="flex justify-between pt-4 border-t">
        <Button variant="outline" onClick={onBack}>
          <ChevronLeft className="h-4 w-4 mr-1" /> Vorige
        </Button>
        {currentLoc < aantal - 1 ? (
          <Button onClick={onNextLoc}
                  style={{ background: "var(--sage)" }} className="text-white">
            Volgende locatie ({currentLoc + 2}/{aantal}) <ChevronRight className="h-4 w-4 ml-1" />
          </Button>
        ) : (
          <Button onClick={onGotoReview}
                  data-testid="wizard-goto-review"
                  style={{ background: "var(--sage)" }} className="text-white">
            Naar controle-overzicht <ChevronRight className="h-4 w-4 ml-1" />
          </Button>
        )}
      </div>
    </Card>
  );
}
